import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CanActivateViaOAuthGuard } from '../oAuth.canActivateGuard';
import  {HomeComponent} from './home/home.component'
//import { AddAdminComponent } from "./add-admin/add-admin.component";
import { OvedDetailsAdminComponent } from "./oved-details-admin/oved-details-admin.component";
import { AdminActivitiesComponent } from "./admin-activities/admin-activities.component";
import { PeiluyotAdminHomeComponent } from "./peiluyot-admin/peiluyot-admin-home/peiluyot-admin-home.component";
import { PeiluyotAdminOvedDetailsComponent } from "./peiluyot-admin/peiluyot-admin-oved-details/peiluyot-admin-oved-details.component";
import { getCanActivateChild } from "@angular/router/src/utils/preactivation";
import { NofeshAdminHomeComponent } from "./nofesh-admin/nofesh-admin-home/nofesh-admin-home.component";
import { MatanotAdminHomeComponent } from "./matanot-admin/matanot-admin-home/matanot-admin-home.component";
import { MatanotAdminOvedDetailsComponent } from "./matanot-admin/matanot-admin-oved-details/matanot-admin-oved-details.component";
import { NofshonimAdminHomeComponent } from "./nofshonim-admin/nofshonim-admin-home/nofshonim-admin-home.component";
import { AdminCanActivateGuard } from "app/shared/guards/admin-can-activate.guard";
import { OvedDetailsComponent } from "./nofesh-nofshonim-oved-admin/oved-details/oved-details.component";
import { OvedHomeComponent } from "./nofesh-nofshonim-oved-admin/oved-home/oved-home.component";
import { NofshonimCharigimComponent } from "./nofshonim-admin/nofshonim-charigim/nofshonim-charigim.component";
import { SinglesUniteComponent } from "./nofesh-admin/singles-unite/singles-unite.component";
import { NofeshAdminReservationsComponent } from "./nofesh-admin/nofesh-admin-reservations/nofesh-admin-reservations.component";
import { NofshonimAdminReservationsComponent } from "./nofshonim-admin/nofshonim-admin-reservations/nofshonim-admin-reservations.component";
import { HamtanaOrBitulComponent } from "./nofesh-admin/hamtana-or-bitul/hamtana-or-bitul.component";
import { HamtanaOrBitulNofshonComponent } from "./nofshonim-admin/hamtana-or-bitul/hamtana-or-bitul.component";
import { UpdatePaymentComponent } from "./nofshonim-admin/update-payment/update-payment.component";
import { ChangeNofshonComponent } from "./nofshonim-admin/change-nofshon/change-nofshon.component";
import { ChangeNofeshComponent } from "./nofesh-admin/change-nofesh/change-nofesh.component";
import { UpdateNofeshPaymentComponent } from "./nofesh-admin/update-nofesh-payment/update-nofesh-payment.component";
import { AddNilveComponent } from "./nofesh-admin/add-nilve/add-nilve.component";
import { ChangeNofeshMultipleComponent } from "./nofesh-admin/change-nofesh-multiple/change-nofesh-multiple.component";
import { HamtanaBitulMultipleComponent } from "./nofesh-admin/hamtana-bitul-multiple/hamtana-bitul-multiple.component";
import { HamtanaBitulNofshonMultipleComponent } from "./nofshonim-admin/hamtana-bitul-nofshon-multiple/hamtana-bitul-nofshon-multiple.component";
import { FindOvedComponent } from "./nofesh-nofshonim-oved-admin/find-oved/find-oved.component";
import { AddNofeshMeurganComponent } from "./nofesh-admin/add-nofesh-meurgan/add-nofesh-meurgan.component";
import { NofeshSummaryComponent } from "./charts/nofesh-charts/nofesh-summary/nofesh-summary.component";
import { NofshonimSummaryComponent } from "./nofshonim-admin/reports/nofshonim-summary/nofshonim-summary.component";
import { NofshonNirshamimComponent } from "./nofshonim-admin/reports/nofshon-nirshamim/nofshon-nirshamim.component";
import { NofshonMamtinimComponent } from "./nofshonim-admin/reports/nofshon-mamtinim/nofshon-mamtinim.component";
import { AddNofeshComponent } from "./nofesh-admin/add-nofesh/add-nofesh.component";





const adminRoutes: Routes = [
    {
      path: 'admin',
      canActivate: [AdminCanActivateGuard, CanActivateViaOAuthGuard], 
      component: HomeComponent,//TODO: BACK TO HOMECOMPONENT
      children: 
      [
        {
            path: 'activities',
            component: AdminActivitiesComponent            
        },
        {
            path: 'charts/nofesh-charts/sumarry',
            component:NofeshSummaryComponent
        },

        //peiluyot
        {   
            path: 'peiluyot-admin/peiluyot-admin-home',
            component: PeiluyotAdminHomeComponent 
        },
        {   
            path: 'peiluyot-admin/peiluyot-admin-oved-details', 
            component: PeiluyotAdminOvedDetailsComponent 
        },
        {   
            path: 'peiluyot-admin', 
            component: PeiluyotAdminHomeComponent 
        },


         //nofesh
         
         //to delete
         {   
            path: 'nofesh-admin/nofesh-admin-home',
            component: NofeshAdminHomeComponent 
        },
        {   
            path: 'nofesh-admin', 
            component: NofeshAdminHomeComponent 
        },
        {   
            path: 'nofesh-admin/reservations', 
            component: NofeshAdminReservationsComponent 
        },
        //

        {   
            path: 'nofesh-admin/singles-unite', 
            component: SinglesUniteComponent 
        },
        {   
            path: 'nofesh-admin/add-nilve', 
            component: AddNilveComponent 
        },
        {   
            path: 'nofesh-admin/hamtana-or-bitul', 
            component: HamtanaOrBitulComponent 
        },
        {
            path:'nofesh-admin/hamtana-or-bitul-multiple',
            component:HamtanaBitulMultipleComponent
        },
        {   
            path: 'nofesh-admin/update-nofesh-payment', 
            component: UpdateNofeshPaymentComponent 
        },
        {   
            path: 'nofesh-admin/change-nofesh', 
            component: ChangeNofeshComponent 
        },
        {
            path:'nofesh-admin/add-nofesh',
            component:AddNofeshComponent
        },

        // to delete
        {
            path:'nofesh-admin/add-nofesh-meurgan',
            component:AddNofeshMeurganComponent
        },
        //

         

        //nofshonim

        // to delete
        {   
            path: 'nofshonim-admin/nofshonim-admin-home',
            component: NofshonimAdminHomeComponent
        },
        {   
            path: 'nofshonim-admin', 
            component: NofshonimAdminHomeComponent 
        },
        {   
            path: 'nofshonim-admin/reservations', 
            component: NofshonimAdminReservationsComponent 
        },
        //

        {   
            path: 'nofshonim-admin/nofshonim-charigim',
            component: NofshonimCharigimComponent
        },
        {
            path: 'nofshonim-admin/hamtana-or-bitul',
            component: HamtanaOrBitulNofshonComponent
        },
        {
            path:'nofshonim-admin/hamtana-or-bitul-multiple',
            component:HamtanaBitulNofshonMultipleComponent
        },
        {
            path: 'nofshonim-admin/update-payment',
            component: UpdatePaymentComponent
        }, 
        {
            path: 'nofshonim-admin/change-nofesh',
            component: ChangeNofshonComponent
        }, 
        {
            path: "nofshonim-admin/reports/nofshonim-summary",
            component: NofshonimSummaryComponent
        },
        {
            path: "nofshonim-admin/reports/nofshon-nirshamim",
            component: NofshonNirshamimComponent
        },
        {
            path: "nofshonim-admin/reports/nofshon-mamtinim",
            component: NofshonMamtinimComponent
        },



        //main oved nofshonim-nofesh
        {   
            path: 'nofesh-nofshonim-oved-admin/oved-home', 
            component: OvedHomeComponent 
        },
        {   
            path: 'nofesh-nofshonim-oved-admin/oved-details', 
            component: OvedDetailsComponent
        },
        
        {   
            path: 'nofesh-nofshonim-oved-admin/find-oved', 
            component: FindOvedComponent 
        },

        //matanot
        {   
            path: 'matanot-admin/matanot-admin-home',
            component: MatanotAdminHomeComponent 
        },
        {   
            path: 'matanot-admin/matanot-admin-oved-details', 
            component: MatanotAdminOvedDetailsComponent 
        },
        {   
            path: 'matanot-admin', 
            component: MatanotAdminHomeComponent 
        },
      ]
    }
  ];
  
  @NgModule({
    imports: [
      RouterModule.forChild(adminRoutes)
    ],
    exports: [
      RouterModule
    ]
  })
  export class AdminRouting {}